import { StoresWidgetID } from '@wix/wixstores-client-core';
import { EcomPlatformViewerScriptContext } from '../../viewer-script/types';
import { IWidgetControllerConfig } from '@wix/native-components-infra';

export function getCartIconControllerConfig(
  context: EcomPlatformViewerScriptContext,
): IWidgetControllerConfig | undefined {
  return context.controllerConfigs.find(
    (c) => c.type === StoresWidgetID.CART_ICON,
  );
}
